module.exports = __webpack_public_path__ + "img/pass_3.ccced70d.png";